import { useRoutes } from 'react-router';
import UserDetailPage from './pages/UserDetailPage';
import UserListPage from './pages/UserListPage';
import { RoutesName } from './state/constants';

export const CiamModule = () => {
  const routes = useRoutes([
    {
      path: RoutesName.users,
      children: [
        {
          element: <UserListPage />,
          index: true,
        },
        {
          path: RoutesName.userDetail,
          element: <UserDetailPage />,
        },
      ],
    },
  ]);

  return <>{routes}</>;
};
